import { RequestServiceConfigurations } from '../../types/services/request.types';

export const DEFAULT_CONFIGURATIONS: RequestServiceConfigurations = {
  APIConfigList: [],
  maxRetries: 1,
  setUpAPITimeout: 2000, // 2 seconds,
  defaultContentType: 'application/json',
};

export enum REQUEST_SERVICE_EVENTS {
  CONGIFURED = 'configured',
}

export const DEFAULT_API_VERSION_FORMAT = '; version=';

export enum REQUEST_ERROR_TYPES {
  API_SETUP_TIMEOUT = 'api-setup-timeout',
  RESOURCE_NOT_FOUND = 404,
  SERVER_FAILURE = 502,
  DEFAULT = 'default',
}

export const REQUEST_ERRORS = {
  [REQUEST_ERROR_TYPES.API_SETUP_TIMEOUT]: {
    message: 'API timed out while trying to setup',
    statusCode: -1,
  },
  [REQUEST_ERROR_TYPES.RESOURCE_NOT_FOUND]: {
    message: 'Resource was not found',
    statusCode: 404,
  },
  [REQUEST_ERROR_TYPES.SERVER_FAILURE]: {
    message: 'Server failed while processing request and could not respond as expected',
    statusCode: 502,
  },
  [REQUEST_ERROR_TYPES.DEFAULT]: {
    message: 'Unknown error',
    statusCode: -2,
  },
} as const;
